/* @ngInject */
function PricingTableSnapshotFactory(QuoteLine, Tax, $rootScope) {
  class PricingTableSnapshot {
    constructor(data, currency, exchangeInfo) {
      this.lines = [];
      this.taxes = [];
      this.showTotals = true;
      this.currency = currency || $rootScope.organization.settings.currency;
      this.exchangeInfo = exchangeInfo || $rootScope.organization.exchangeRates;

      if (data) this.setData(data);
      else this.setDefaultValues();
    }

    setDefaultValues() {
      if ($rootScope.organization.settings.taxes) {
        this.setTaxes(
          $rootScope.organization.settings.taxes.filter((tax) => tax.default)
        );
      }
    }

    setData(data) {
      this.showTotals = data.showTotals;
      if (data && data.lines)
        this._updateLines(data.lines, this.exchangeInfo.rates);
      if (data && data.taxes) this._updateTaxes(data.taxes);
    }

    addLine(quoteLine) {
      this.lines.push(new QuoteLine(quoteLine, this.exchangeInfo.rates));
    }

    deleteLine(index) {
      this.lines.splice(index, 1);
    }

    downLine(index) {
      const line = this.lines[index];
      this.lines.splice(index, 1);
      this.lines.splice(index + 1, 0, line);
    }

    upLine(index) {
      const line = this.lines[index];
      this.lines.splice(index, 1);
      this.lines.splice(index - 1, 0, line);
    }

    getSubtotal() {
      let subtotal = 0;

      for (const line of this.lines) {
        if (!line.selectable || (line.selectable && line.selectedByClient))
          subtotal += line.getTotal();
      }

      return subtotal;
    }

    getTotal() {
      const subtotal = this.getSubtotal();

      return this.taxes.reduce(
        (sum, tax) => sum + tax.getValue(subtotal),
        subtotal
      );
    }

    setTaxes(taxes) {
      taxes.forEach((tax) => {
        this.addTax(tax);
      });
    }

    addTax(tax) {
      if (this.taxes.length < 20) this.taxes.push(new Tax(tax));
    }

    removeTax(index) {
      this.taxes.splice(index, 1);
    }

    showSubtotal() {
      return this.taxes.length > 0;
    }

    showDiscounts() {
      return this.lines.some((line) => line.discount > 0);
    }

    anyLineSelectable() {
      return this.lines.some((line) => line.selectable === true);
    }

    anyLineCosts() {
      let anyLineCosts = false;
      this.lines.forEach((line) => {
        if (line.costs.length > 0) anyLineCosts = true;
      });

      return anyLineCosts;
    }

    updateCurrency(oldCurrency, newCurrency) {
      if (!this.lines || this.lines.length === 0) return;

      this.currency = newCurrency;
      this.lines.forEach((line) => {
        line.recalculatePrice(
          this.exchangeInfo.rates,
          oldCurrency,
          this.currency
        );
      });
      this._updateLines(this.lines, this.exchangeInfo.rates);
    }

    _updateLines(linesData, rates) {
      for (let i = 0; i < linesData.length; i++) {
        if (this.lines[i]) {
          linesData[i].currency = this.currency;
          this.lines[i].setData(linesData[i], rates);
        } else {
          linesData[i].currency = this.currency;
          this.addLine(linesData[i]);
        }
      }

      if (this.lines.length > linesData.length) {
        this.lines = this.lines.slice(0, linesData.length);
      }
    }

    _updateTaxes(data) {
      for (let i = 0; i < data.length; i++) {
        if (this.taxes[i]) {
          this.taxes[i].setData(data[i]);
        } else {
          this.addTax(data[i]);
        }
      }

      if (this.taxes.length > data.length) {
        this.taxes = this.taxes.slice(0, data.length);
      }
    }
  }

  return PricingTableSnapshot;
}

export default PricingTableSnapshotFactory;
